(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsActivitiesPanelList', rmsActivitiesPanelList);

    function rmsActivitiesPanelList() {
        return {
            restrict: 'E',
            templateUrl: 'common/app/components/activities/list-panel/activities-panel-list',
            controller: rmsActivitiesPanelListCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {}
        };
    }

    function rmsActivitiesPanelListCtrl(ActivitiesService, lodash, filterBarAdapter, GenericModel, $timeout, EventsRunner) {
        var vm = this;
        this.$onInit = function() {

            ActivitiesService.sync(vm);
            lodash.set(vm.pageData.options, 'activities.reply_options.submitReply', submitReply);

            vm.refreshActivities = ActivitiesService.refreshActivities;
            vm.resetFilters = resetFilters;

            init();
        }

        function init() {
            if (lodash.has(vm.pageData.options, 'activities.filters')) {
                vm.filterOptions = lodash.get(vm.pageData.options, 'activities.filters', {});
            }

            if (lodash.has(vm.pageData.options, 'activities.datasource')) {
                vm.listDataSource = angular.merge(
                    {},
                    {
                        transport: {
                            read: dataSourceRead
                        }

                    },
                    lodash.get(vm.pageData.options, 'activities.datasourceOptions', {})
                );
            }

            vm.gridOptions = angular.merge(
                {
                    height: 'auto',
                    // dataBound: () => {
                    //     angular.element(".k-group-col,.k-group-cell").remove();
                    //     var spanCells = angular.element(".k-grouping-row").children("td");
                    //     spanCells.attr("colspan", spanCells.attr("colspan") - 1);
                    //
                    //
                    // },
                    dataBound: function(e) {
                        angular.element(".k-group-col,.k-group-cell").remove();
                        var spanCells = angular.element(".k-grouping-row").children("td");
                        spanCells.attr("colspan", spanCells.attr("colspan") - 1);
                    },
                    pageable: {
                        refresh: true
                    },
                    scrollable:{
                        virtual:true
                    }
                },
                lodash.get(vm.pageData.options, 'activities.gridOptions')
            );
        }

        function resetFilters() {
            vm.resetQuery();
        }

        function dataSourceRead(readOptions) {
            let filters = {};
            if (typeof vm.getQuery == typeof function() {}) {
                filters = { filter: filterBarAdapter(vm.getQuery()) };
            } 
            if (lodash.has(vm.pageData.options, 'activities.data')) {
                $timeout(() => {
                    readOptions.success(vm.pageData.options.activities.data);
                }, 1200);
            } else {
                let model, method;
                if ((!lodash.has(filters, 'filter') || filters.filter.length == 0) && lodash.isEmpty(filters.sort)) {
                    model = new GenericModel('/' + vm.pageData.options.activities.datasource.read.url);
                    method = lodash.get(vm.pageData.options.activities.datasource, 'read.method', 'get');
                } else {
                    model = new GenericModel('/' + vm.pageData.options.activities.datasource.filter.url);
                    method = lodash.get(vm.pageData.options.activities.datasource, 'filter.method', 'get');
                }

                // {data: params} applied in generateResourceOption
                // const data = generateResourceOption(readOptions.data, myOptions, method);
                const data = generateResourceOption(readOptions.data, filters, method);
                model[method](data).$promise.then((res) => {
                    readOptions.success(res);
                }, (err)=> {
                    readOptions.error(err);
                });
            }
        }

        function generateResourceOption(resourceData, myData, method) {
            var params = {};
            params = angular.merge(params, resourceData, myData);

            if (method != 'get') {
                params = {'data': params};
            }
            return params;
        }

        function submitReply(data) {
            const promise = EventsRunner(vm.pageData.options.activities.reply_options.events, vm.pageData.options.activities.reply_options.event_trigger.submit_reply, data);
            return promise;
        }
    }
})();
